import React from 'react';

const EmptyMessage = ({ text = 'No Data', children }) => (React.createElement("div", { className: "empty-message" }, children || text));

export { EmptyMessage as default };
//# sourceMappingURL=index.js.map
